import React, { createContext, useContext, useState, ReactNode } from 'react';
import { StyleTemplate } from '../types/template';

interface TemplateContextType {
  templates: StyleTemplate[];
  setTemplates: (templates: StyleTemplate[]) => void;
  getTemplateById: (id: string) => StyleTemplate | undefined;
  addTemplate: (template: StyleTemplate) => void;
}

const TemplateContext = createContext<TemplateContextType | undefined>(undefined);

interface TemplateProviderProps {
  children: ReactNode;
}

export const TemplateProvider: React.FC<TemplateProviderProps> = ({ children }) => {
  const [templates, setTemplates] = useState<StyleTemplate[]>([]);

  const getTemplateById = (id: string): StyleTemplate | undefined => {
    return templates.find(template => template.id === id);
  };

  const addTemplate = (template: StyleTemplate) => {
    setTemplates(prev => {
      const exists = prev.find(t => t.id === template.id);
      if (exists) {
        return prev;
      }
      return [...prev, template];
    });
  };

  return (
    <TemplateContext.Provider value={{
      templates,
      setTemplates,
      getTemplateById,
      addTemplate
    }}>
      {children}
    </TemplateContext.Provider>
  );
};

export const useTemplate = () => {
  const context = useContext(TemplateContext);
  if (context === undefined) {
    throw new Error('useTemplate must be used within a TemplateProvider');
  }
  return context;
};
